import { defineComponent as _defineComponent } from 'vue';
import { productGetters } from '@vsf-enterprise/commercetools';
import { generateVariantString } from '~/utils';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzPanelAddedToCartProductList',
  props: {
    products: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;

    /**
     * Gets the product price.
     *
     * @param      {NormalizedProductVariantModels.Root}  product  The product
     * @return     {PriceUnitModel}                       The product prices.
     */
    function getProductPrice(product) {
      var _price$regular, _price$special;
      var price = productGetters.getPrice(product);
      return {
        regular: (_price$regular = price === null || price === void 0 ? void 0 : price.regular) !== null && _price$regular !== void 0 ? _price$regular : 0,
        special: (_price$special = price === null || price === void 0 ? void 0 : price.special) !== null && _price$special !== void 0 ? _price$special : 0
      };
    }

    /**
     * Gets the variant name.
     *
     * @param      {NormalizedProductVariantModels.Root}  product  The product
     * @return     {string}                               The variant name.
     */
    function getVariantName(product) {
      return generateVariantString(product, i18n.locale);
    }
    return {
      __sfc: true,
      props: props,
      i18n: i18n,
      getProductPrice: getProductPrice,
      getVariantName: getVariantName,
      PriceDisplay: PriceDisplay,
      AzImg: AzImg
    };
  }
});